export function isLodItem(item) {
    return item.lods !== undefined;
}
